import React, {Component, ReactElement, ReactNode, RefObject} from 'react'
import NatMessageRepo from '../message/repository/NatMessageRepo'
import NatCurrentDateTimeRepo from '../currentDateTime/repository/NatCurrentDateTimeRepo'
import {MessageFile, MessageNotDeliveryCondominium, NatGetMessage} from './repository/NatGetMessage'
import {
    ADMINISTORATOR_MODE,
    AVAILABLE_OR_NOT,
    HAVE_OR_NOT,
    MESSAGE_CATEGORY,
    MESSAGE_TYPE,
    PREFECTURES_MASTER,
    ROLE_FOR_ADMINISTRATOR,
    SET_EXISTENCE,
    VALID_OR_NOT,
    YES_OR_NOT,
} from '../../../CodeMaster'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {Nullable} from '../../../app/TypeHelpers'
import NatCondominiumGroupRepo from '../condominiumGroup/repository/NatCondominiumGroupRepo'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea,
} from '../../../components/shared/hoc/withAdminPageTemplate'
import {BackLink, DeleteLink} from '../../../styledComponents/adminPage/Links'
import {
    InnerMiniTable,
    InnerMiniTableBody,
    InnerMiniTableCell,
    StyledTableCaption,
    TableRowName
} from '../../../styledComponents/adminPage/Table';
import AuthorityChecker from '../../../components/AuthorityChecker';
import {HKConstants} from '../../../HKConstants';
import {Box, Link, Table, TableBody, TableCell, TableRow} from '@mui/material';
import {AdminPrimaryButton} from '../../../styledComponents/adminPage/Buttons';
import {Messages} from '../../../Messages';
import styled from 'styled-components';
import {NatDeleteMessage} from './repository/NatDeleteMessage';
import {HeadingAreaMessageParams} from '../../../components/shared/pageBaseComponents/HeadingAreaMessageComponent';
import {isIE} from 'react-device-detect';
import {
    BillingStatus,
    CondominiumInfo,
    NatGetCondominiumList,
    SearchCondition,
    SearchConditionPageInfo,
} from '../condominium/repository/NatGetCondominiumList'
import {SortOrder} from '../../../components/shared/SortOrder'
import NatCondominiumRepo from '../condominium/repository/NatCondominiumRepo'
import {Colors} from '../../../styledComponents/Constants'
import {DeleteAlertIcon} from '../../../styledComponents/adminPage/IconCreator'
import HintButton from '../../../components/shared/pageBaseComponents/HintButton'
import {Location} from 'react-router-dom'
import ReactDOM from 'react-dom'

const KEY_SELECTED_ADMINISTORATOR_MODE: string = 'selectedMode'
const KEY_SELECTED_CONDOMINIUM_CD: string = 'selectedCondominiumCd'
const KEY_LOGIN_USER_ROLE_ID: string = 'loginUserRoleId'

interface Props {
    messageId: string
    messageRepo: NatMessageRepo,
    condominiumGroupRepo: NatCondominiumGroupRepo
    condominiumRepo: NatCondominiumRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
    eventEmitter: EventEmitterExAdmin
    location: Location
}

interface States {
    condominiumGroupName: string,
    deliveryTargetPrefectureCd: string,
    deliveryTargetAddress2: string,
    messageDeliveryTargetCondominiumList: CondominiumInfo[],
    categoryId: string
    title: string
    description: string,
    publishStartDate: string
    publishEndDate: string
    topFixed: string
    messageFileList: MessageFile[]
    notDeliveryCondominiumList: MessageNotDeliveryCondominium[]
    isLoadCompleted: boolean
    deleteImpossibleFlg: boolean
    copyAvailability: string
    doNotify: string
    notifiedFlag: string
    deleteLinkDisabled: boolean
}

class NatAdminMessagePage extends Component<Props & AdminPagePropsSet, States> {
    mode: Nullable<string>
    condominiumCd: Nullable<string>
    loginUserRoleId: Nullable<string>
    messageFile: RefObject<HTMLInputElement>

    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        this.mode = SessionStorageHelper.getStringItemOrNull(KEY_SELECTED_ADMINISTORATOR_MODE)
        this.condominiumCd = SessionStorageHelper.getStringItemOrNull(KEY_SELECTED_CONDOMINIUM_CD)
        this.loginUserRoleId = SessionStorageHelper.getStringItemOrNull(KEY_LOGIN_USER_ROLE_ID)

        this.state = {
            condominiumGroupName: '',
            deliveryTargetPrefectureCd: '',
            deliveryTargetAddress2: '',
            messageDeliveryTargetCondominiumList: [],
            categoryId: '',
            title: '',
            description: '',
            publishStartDate: '',
            publishEndDate: '',
            topFixed: '',
            messageFileList: [],
            notDeliveryCondominiumList: [],
            isLoadCompleted: false,
            deleteImpossibleFlg: false,
            copyAvailability: '',
            doNotify: SET_EXISTENCE.NOT.value,
            notifiedFlag: HAVE_OR_NOT.NOT.value,
            deleteLinkDisabled: true,
        }
        this.messageFile = React.createRef()

        this.deleteMessage = this.deleteMessage.bind(this)
        this.renderPageHeaderArea = this.renderPageHeaderArea.bind(this)
        this.handleRegisterCancelClick = this.handleRegisterCancelClick.bind(this)
        this.handleDeleteOkClick = this.handleDeleteOkClick.bind(this)
        this.editMessageButton = this.editMessageButton.bind(this)
        this.copyMessageButton = this.copyMessageButton.bind(this)
    }

    async componentDidMount(): Promise<void> {

        await this.props.eventEmitter.showLoading()
        try {
            // メッセージ取得
            const getMessageResponse: Nullable<NatGetMessage> = await this.props.asyncCallFunction(
                this.props.messageRepo.getMessage.bind(this.props.messageRepo, this.props.messageId),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (getMessageResponse && getMessageResponse.details) {
                const notDeliveryCondominiumList: MessageNotDeliveryCondominium[] = []
                if (getMessageResponse.details.messageNotDeliveryCondominium) {
                    getMessageResponse.details.messageNotDeliveryCondominium.forEach((notDeliveryCondominium) => {
                        const notDeliveryCondominiumInfo: MessageNotDeliveryCondominium = {
                            condominiumCd: notDeliveryCondominium.condominiumCd,
                            condominiumName: notDeliveryCondominium.condominiumName,
                        }
                        notDeliveryCondominiumList.push(notDeliveryCondominiumInfo)
                    })
                }
                const messageFileList: MessageFile[] = []
                if (getMessageResponse.details.messageFile) {
                    getMessageResponse.details.messageFile.forEach((file) => {
                        const messageFileInfo: MessageFile = {
                            fileNumber: file.fileNumber,
                            sortOrder: file.sortOrder,
                            publishMaterialName: file.publishMaterialName,
                            fileName: file.fileName,
                            path: file.path,
                        }
                        messageFileList.push(messageFileInfo)
                    })
                }

                // 削除可否
                let deleteImpossibleFlg: boolean = getMessageResponse.details.controlFlag === YES_OR_NOT.NO.value

                // 管理組合役員の場合、カテゴリが"管理組合より"と"自治会のみ"の場合のみ削除可能
                if (!deleteImpossibleFlg && this.loginUserRoleId === ROLE_FOR_ADMINISTRATOR.ASSOC.value) {
                    if (getMessageResponse.details.categoryId !== MESSAGE_CATEGORY.ASSOC.value &&
                        getMessageResponse.details.categoryId !== MESSAGE_CATEGORY.RESIDENTS_ASSOCIATION.value
                    ) {
                        deleteImpossibleFlg = true
                    }
                }

                ReactDOM.flushSync(() => {
                    if (getMessageResponse && getMessageResponse.details) {
                        this.setState({
                            condominiumGroupName: getMessageResponse.details.condominiumGroupName,
                            deliveryTargetPrefectureCd: getMessageResponse.details.deliveryTargetPrefectureCd ?
                                getMessageResponse.details.deliveryTargetPrefectureCd : '',
                            deliveryTargetAddress2: getMessageResponse.details.deliveryTargetAddress2 ?
                                getMessageResponse.details.deliveryTargetAddress2 : '',
                            title: getMessageResponse.details.title,
                            description: getMessageResponse.details.description,
                            publishStartDate: getMessageResponse.details.publishStartDate,
                            publishEndDate: getMessageResponse.details.publishEndDate,
                            categoryId: getMessageResponse.details.categoryId,
                            topFixed: getMessageResponse.details.topFixed,
                            copyAvailability: getMessageResponse.details.copyAvailability,
                            doNotify: getMessageResponse.details.doNotify,
                            notifiedFlag: getMessageResponse.details.notifiedFlag,
                            messageFileList: messageFileList,
                            notDeliveryCondominiumList: notDeliveryCondominiumList,
                            deleteImpossibleFlg: deleteImpossibleFlg,
                            deleteLinkDisabled: getMessageResponse.details.notifiedFlag === HAVE_OR_NOT.HAVE.value &&
                                !(this.loginUserRoleId === ROLE_FOR_ADMINISTRATOR.SYSTEM_ADMIN.value),
                        })
                    }
                })
                // 配信対象物件一覧の設定
                await this.getSelectedDeliveryTargetCondominiumInfo(
                    getMessageResponse.details.condominiumGroupId,
                    this.state.deliveryTargetPrefectureCd,
                    this.state.deliveryTargetAddress2,
                )
            }
            this.showInitialMessage()
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }

    }

    // 配信対象物件一覧の取得
    async getSelectedDeliveryTargetCondominiumInfo(
        condominiumGroupId: Nullable<number>,
        deliveryTargetPrefectureCd: Nullable<string>,
        deliveryTargetAddress2: Nullable<string>,
    ): Promise<void> {
        if (deliveryTargetPrefectureCd !== '' || deliveryTargetAddress2 !== '') {
            const billingStatus: BillingStatus = {
                billingDeadline: null,
                confirmStatus: null,
                targetYearMonth: null,
                electedTargetYearMonth: null,
            }
            const searchCondition: SearchCondition = {
                condominiumCd: null,
                condominiumName: null,
                condominiumGroupId: condominiumGroupId,
                prefectureCd: deliveryTargetPrefectureCd,
                address2: deliveryTargetAddress2,
                detailSearchCondition: null,
                billingStatus: billingStatus,
                unreleaseCondominiumExclusionFlg: null,
            }
            const searchConditionPageInfo: SearchConditionPageInfo = {
                pageNum: 0,
                page: 0,
            }
            const searchConditionSortInfo: SortOrder[] = [new SortOrder('condominiumCd', 'asc')]

            this.setState({
                messageDeliveryTargetCondominiumList:
                    await this.searchCondominiums(
                        searchCondition,
                        searchConditionPageInfo,
                        searchConditionSortInfo),
            })
        }
    }

    // 物件一覧検索結果の取得
    async searchCondominiums(
        searchCondition: SearchCondition,
        searchConditionPageInfo: SearchConditionPageInfo,
        searchConditionSortInfo: SortOrder[],
    ): Promise<CondominiumInfo[]> {
        const searchParams: string[] = []

        if (searchConditionSortInfo) {

            searchConditionSortInfo.forEach((sortInfo) => {
                const value: string = `${sortInfo.sortKey}:${sortInfo.sortDirection}`
                searchParams.push(`sortInfo=${value}`)
            })
        }

        // 物件一覧取得
        const getCondominiumResponse: Nullable<NatGetCondominiumList> =
            await this.props.asyncCallFunction(
                this.props.condominiumRepo.getCondominiumList.bind(
                    this.props.condominiumRepo,
                    {...searchCondition, ...searchConditionPageInfo, sortInfo: searchParams},
                ),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )

        if (getCondominiumResponse) {
            if (getCondominiumResponse.details) {
                return getCondominiumResponse.details.condominiumInfo
            }
        }
        return []
    }

    showInitialMessage(): void {
        if (!this.props.location || !this.props.location.state) {
            return
        }
        const initialMessage: HeadingAreaMessageParams = this.props.location.state.initialMessage
        this.props.navigate(this.props.location.pathname, {replace: true})
        this.props.eventEmitter.showHeadingAreaMessage(initialMessage)
    }

    render(): ReactElement {
        if (!this.state.isLoadCompleted) {
            return (<></>)
        }
        return (
            <>
                <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.EDIT_MESSAGE}>
                    <Box mb={'15px'}>
                        <PageFooterArea>
                            {this.renderPageHeaderArea()}
                        </PageFooterArea>
                    </Box>
                </AuthorityChecker>
                <PageMainArea>
                    {this.renderInputFormTable()}
                </PageMainArea>
                <PageFooterArea>
                    {this.renderPageFooterArea()}
                </PageFooterArea>
            </>

        )
    }

    renderPageHeaderArea(): Nullable<ReactNode> {
        if (this.state.copyAvailability === AVAILABLE_OR_NOT.AVAILABLE.value &&
            this.mode === ADMINISTORATOR_MODE.CONDOMINIUM.value) {
            return (
                <>
                    <PageFotterAreaLeft>
                        <AdminPrimaryButton
                            onClick={this.copyMessageButton}>
                            コピー
                        </AdminPrimaryButton>
                    </PageFotterAreaLeft>
                </>
            )
        }
        if (this.state.deleteImpossibleFlg) {
            return (<></>)
        }
        return (
            <>
                <PageFotterAreaRight>
                    <DeleteLink
                        disabled={this.state.deleteLinkDisabled}
                        linkColor={Colors.Alert}
                        onClick={this.deleteMessage}>
                        メッセージを削除する
                    </DeleteLink>
                    <HintButton message={Messages.HNTFA0003.message}/>
                </PageFotterAreaRight>
                <PageFotterAreaLeft>
                    <AdminPrimaryButton
                        onClick={this.editMessageButton}>
                        編集する
                    </AdminPrimaryButton>
                </PageFotterAreaLeft>
            </>
        )
    }

    editMessageButton(): void {
        this.props.navigate(`/admin/messageEdit/${this.props.messageId}`)
    }

    copyMessageButton(): void {
        this.props.navigate(`/admin/messageRegister/`, {state: this.props.messageId})
    }


    // 削除ボタン押下
    async deleteMessage(): Promise<void> {
        await this.props.eventEmitter.showDialog({
                title: '削除確認',
                titleIcon: <DeleteAlertIcon/>,
                errorLevel: Messages.IOPCC0027.errorLevel,
                message: Messages.IOPCC0027.toString(this.state.title),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: '削除する',
                        buttonHandler: this.handleDeleteOkClick,
                        color: Colors.Alert,
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.handleRegisterCancelClick,
                    },
                ],
            },
        )
    }

    handleRegisterCancelClick(): void {
        this.props.eventEmitter.closeDialog()
    }

    async handleDeleteOkClick(): Promise<void> {
        this.props.eventEmitter.closeDialog()
        await this.props.eventEmitter.showLoading()
        try {

            const deleteMessageResponse: Nullable<NatDeleteMessage> = await this.props.asyncCallFunction(
                this.props.messageRepo.deleteMessage.bind(
                    this.props.messageRepo, this.props.messageId),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
            )
            if (deleteMessageResponse && deleteMessageResponse.requestError === null) {
                this.props.navigate(`/admin/messageList`,
                    {
                        state: {
                            initialMessage: {
                                title: null,
                                messageLevel: MESSAGE_TYPE.INFORMATION,
                                detail: Messages.IOPCC0006.toString('メッセージ', this.state.title),
                            },
                        },
                    },
                )
            }

        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }


    renderInputFormTable(): ReactNode {
        return <>
            <Table>
                <StyledTableCaption>メッセージ情報</StyledTableCaption>
                <TableBody>
                    {this.mode === ADMINISTORATOR_MODE.ALL.value &&
                        <>
                            <TableRow>
                                <TableRowName>掲載範囲</TableRowName>
                                <TableCell colSpan={3}>
                                    {this.state.condominiumGroupName}
                                </TableCell>
                            </TableRow>
                            {this.state.deliveryTargetPrefectureCd !== '' || this.state.deliveryTargetAddress2 !== '' ?
                                <>
                                    <TableRow>
                                        <TableRowName>
                                            配信対象
                                        </TableRowName>
                                        <TableCell colSpan={4}>
                                            {`指定地域: ${this.getPrefectureName(this.state.deliveryTargetPrefectureCd)}
                                            ${this.state.deliveryTargetAddress2}`}
                                            {
                                                <InnerMiniTable>
                                                    <InnerMiniTableBody>
                                                        {
                                                            this.state.messageDeliveryTargetCondominiumList.map(
                                                                (condominiumInfo, index) => {
                                                                    return (
                                                                        <TableRow key={condominiumInfo.condominiumCd}>
                                                                            <InnerMiniTableCell>
                                                                                {condominiumInfo.condominiumCd + ' ' +
                                                                                    condominiumInfo.condominiumName}
                                                                            </InnerMiniTableCell>
                                                                        </TableRow>
                                                                    )
                                                                })
                                                        }
                                                    </InnerMiniTableBody>
                                                </InnerMiniTable>
                                            }
                                        </TableCell>
                                    </TableRow>
                                </>
                                : <></>
                            }
                        </>
                    }
                    {this.mode === ADMINISTORATOR_MODE.ALL.value &&
                        this.state.notDeliveryCondominiumList.length > 0 &&
                        this.state.notDeliveryCondominiumList.map((notDeliveryCondominium, index) => (
                            <TableRow key={'notDeliveryCondominium_' + notDeliveryCondominium.condominiumCd}>
                                {index === 0 &&
                                    <TableRowName rowSpan={this.state.notDeliveryCondominiumList.length}>
                                        除外する物件
                                    </TableRowName>
                                }
                                <TableCell colSpan={3}>
                                    {notDeliveryCondominium.condominiumCd} {notDeliveryCondominium.condominiumName}
                                </TableCell>
                            </TableRow>
                        ))
                    }

                    <TableRow>
                        <TableRowName>カテゴリ</TableRowName>
                        <TableCell colSpan={3}>
                            {this.getMessageCategoryLabel(this.state.categoryId)}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableRowName>タイトル</TableRowName>
                        <TableCell colSpan={3}>
                            {this.state.title}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableRowName>本文</TableRowName>
                        <TableCellWordBreakAll colSpan={3}>
                            <div dangerouslySetInnerHTML={{__html: this.state.description}}/>
                        </TableCellWordBreakAll>
                    </TableRow>
                    <TableRow>
                        <TableRowName>掲載開始日</TableRowName>
                        <TableCell colSpan={3}>
                            {this.state.publishStartDate}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableRowName>掲載終了日</TableRowName>
                        <TableCell colSpan={3}>
                            {this.state.publishEndDate}
                        </TableCell>
                    </TableRow>
                    {this.mode === ADMINISTORATOR_MODE.CONDOMINIUM.value &&
                        <TableRow>
                            <TableRowName>上位固定</TableRowName>
                            <TableCell colSpan={3}>
                                {this.getValidOrNotCheckLabel(this.state.topFixed)}
                            </TableCell>
                        </TableRow>
                    }
                    <TableRow>
                        <TableRowName>コピー可否</TableRowName>
                        <TableCell colSpan={3}>
                            {this.getMessageCopyAvailabilityLabel(this.state.copyAvailability)}
                        </TableCell>
                    </TableRow>

                    {this.state.messageFileList.map((messageFile, index) => (
                        <TableRow key={'messageFile_' + messageFile.fileNumber}>
                            {index === 0 &&
                                <TableRowName rowSpan={this.state.messageFileList.length}>掲載資料</TableRowName>
                            }
                            <MessageFileIconCell>
                                {(isIE) ?
                                    <Link
                                        onClick={() => window.open(messageFile.path)}
                                        target={'_blank'}
                                        underline="hover">
                                        <img src={`/resources/images/icons/icon_pdf.png`}
                                             alt=""/>
                                    </Link> :
                                    <Link href={messageFile.path} target={'_blank'} underline="hover">
                                        <img src={`/resources/images/icons/icon_pdf.png`}
                                             alt=""/>
                                    </Link>
                                }
                            </MessageFileIconCell>
                            <TableCell>
                                {messageFile.publishMaterialName}
                            </TableCell>
                            <TableCell>並び順 {messageFile.sortOrder}</TableCell>
                        </TableRow>
                    ))
                    }
                    <TableRow>
                        <TableRowName>通知有無</TableRowName>
                        <TableCell colSpan={3}>
                            {SET_EXISTENCE.codeToEnumConstants(this.state.doNotify)?.label}
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </>
    }

    getMessageCategoryLabel(categoryId: string): string {
        let messageCategoryLabel: any
        messageCategoryLabel = MESSAGE_CATEGORY.codeToEnumConstants(categoryId)
        if (messageCategoryLabel) {
            return messageCategoryLabel.label
        } else {
            return ''
        }
    }

    getMessageCopyAvailabilityLabel(copyAvailability: string): string {
        let messageCopyAvailabilityLabel: any
        messageCopyAvailabilityLabel = AVAILABLE_OR_NOT.codeToEnumConstants(copyAvailability)
        if (messageCopyAvailabilityLabel) {
            return messageCopyAvailabilityLabel.label
        } else {
            return ''
        }
    }

    getValidOrNotCheckLabel(isValid: string): string {
        let validOrNotCheckLabel: any
        validOrNotCheckLabel = VALID_OR_NOT.codeToEnumConstants(isValid)
        if (validOrNotCheckLabel) {
            return validOrNotCheckLabel.label
        } else {
            return ''
        }
    }

    getPrefectureName(prefectureCd: string): string {
        if (prefectureCd) {
            const prefecturesMaster = PREFECTURES_MASTER.codeToEnumConstants(prefectureCd)
            return prefecturesMaster.label
        } else {
            return ''
        }
    }

    renderPageFooterArea(): ReactNode {

        return (
            <>
                <PageFotterAreaRight>
                </PageFotterAreaRight>
                <PageFotterAreaLeft>
                    <BackLink
                        to={`/admin/messageList`}
                    >
                        メッセージ検索へ戻る
                    </BackLink>
                </PageFotterAreaLeft>
            </>
        )
    }
}

export default createAdminPage(NatAdminMessagePage)

const MessageFileIconCell = styled(TableCell)`
  &.MuiTableCell-root {
    width: 100px;
  }
`

const TableCellWordBreakAll = styled(TableCell)`
  &.MuiTableCell-root {
    word-break: break-all;
  }
`
